// import config from '../server/config'
import { fetchPageData } from './fetchPageData';

export default function  FetchHook({offset,limit}) {
    // let location = useLocation()
    // const [hookRes,setHookRes] = useState([])
    let cancel;
    let hookRes = []				
    let endpoint = window?.cachedAPI
    let parsedCountryCode = window.pageData?.countryCode || "IN" //(countryCode && countryCode.country && (countryCode.country).toLowerCase()) || ""
    let variables = {
      site: (window?.app_data?.site?.siteInternalName) || null,
      path: window?.location?.pathname,
      device: "WEB",
      includeContent: true,
      moduleLimit: limit,
      moduleOffset: offset,
      languageCode: "en",
      countryCode: parsedCountryCode,
      userState: null,
      modules: []
    }
    return fetchPageData(variables,endpoint)
    // return () => cancel()
  
}